
import "./GlPlanList.scss";
import { useSelector } from "react-redux";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { GridLoader, ScaleLoader } from "react-spinners";
import { MdAdd, MdArrowBackIos, MdClose } from "react-icons/md";
import { FiSearch } from "react-icons/fi";
import CircularButton, { CustomLoadingButton } from "../../../components/ui/CustomButton";
import newRequest from "../../../utils/newRequest";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog";
import { useTranslation } from "react-i18next";
import { getCssValue } from "../../../utils/genericFunctions";
import { useLocation, useNavigate } from "react-router-dom";
import { IoDocumentTextSharp } from "react-icons/io5";
import { IoIosRefresh } from "react-icons/io";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports";



const GlPlanList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const showBack = location.state?.showBack || "N";
  const { currentTheme } = useSelector((state) => state.theme);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [isLoading, setIsLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currencyAction, setCurrencyAction] = useState("");
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    action_invoked: "",
  });
  const [reportGroupArray, setReportKeysArray] = useState(["ri-batcheses"]);
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(10);



  const [currentPlanPage, setCurrentPlanPage] = useState(0);
  const handlePlansPageChange = (event, newPage) => {
    setCurrentPlanPage(newPage);
  };

  const filteredPlans = plans?.filter(
    (row) =>
      row?.plan_code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row?.plan_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row?.plan_financial_year
  );

  const paginatedPlans = filteredPlans?.slice(
    currentPlanPage * rowsPerPage,
    currentPlanPage * rowsPerPage + rowsPerPage
  );



  const handleSearchPlan = async () => {
    try {
      if (searchTerm) {
        setIsLoading(true);
        const res = await newRequest.post("/planning/search", { search_input: searchTerm, lean: true });
        setPlans(res.data);
      } else {
        await fetchPlans();
      }
    } catch (error) {
      console.error("Error searching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePlansRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPlanPage(0);
  };

  const fetchPlans = async () => {
    try {
      const res = await newRequest.post(
        "/planning/findAll", { lean: true, result_limit: 100 }
      );
      setPlans(res.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };



  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "deletePlan") {

      }
    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };

  const handleCancel = () => {
    setIsConfirmDialogOpen(false);
  };

  const handleCloseNotifyDialog = () => {
    setIsNotifyDialogOpen(false);
  };


  const whenViewMounts = async () => {
    try {
      setIsLoading(true);
      fetchPlans();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    whenViewMounts();
  }, []);

  const handlePlansChange = (e, rowId) => {
    try {
      const { name, value } = e.target;
      const updatedData = [...plans];
      const rowIndex = updatedData.findIndex(item => item._id === rowId);

      if (rowIndex === -1) {
        throw new Error('Row not found');
      }
      updatedData[rowIndex][name] = value;
      updatedData[rowIndex]["changed_xx"] = "Y";

      setPlans(updatedData);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="plan-list">
      {isLoading ? (
        <div className="no-content">
            <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <motion.div
          className="plan-list-main-wrapper"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}>
          <div className="plan-list-toolbar">
            <div className="plan-list-rightleft">
              <div className="search-input-wrapper" style={{ width: "100%%x" }}>
                <FiSearch className="search-input-icon" />
                <input
                  className="search-input"
                  type="text"
                  placeholder={`${t('search')} ${t('plan')}`}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') handleSearchPlan();
                  }}
                />
                {searchTerm.length > 0 && (
                  <MdClose
                    onClick={async (e) => {
                      try {
                        setSearchTerm("");
                        await fetchPlans();
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                    className="search-input-icon"
                  />
                )}
                {searchTerm.length === 0 && (
                  <span className="search-input-icon" />
                )}
              </div>
            </div>
            <div className="plan-list-right">
              <CustomLoadingButton
                currentTheme={currentTheme}
                iconPosition="end"
                borderRadiusType="both"
                variant="tint"
                color="#2563EB"
                tooltip="Run forecast reports"
                endIcon={<IoDocumentTextSharp />}
                onClick={() => setReportsDialogOpen(true)}>
                {t('reports')}
              </CustomLoadingButton>
              <CustomLoadingButton
                currentTheme={currentTheme}
                iconPosition="end"
                borderRadiusType="both"
                variant="tint"
                color="#0f766e5d"
                endIcon={<IoIosRefresh />} onClick={fetchPlans}>
                {t('refresh')}
              </CustomLoadingButton>
              <CustomLoadingButton
                currentTheme={currentTheme}
                iconPosition="end"
                borderRadiusType="both"
                variant="tint"
                color="#0ea5a4"
                tooltip={t('newForecast')}
                endIcon={<MdAdd />}
                onClick={() => navigate(`/planning/new`)}
              >
                {t('newForecast')}
              </CustomLoadingButton>
              {/* This part shows if the menu was opened from home screen */}
              {showBack === "Y" && <hr className="separator-v" />}
              {showBack === "Y" &&
                <span className="back-icon" onClick={() => navigate(-1)}>
                  <MdArrowBackIos size={24} />
                </span>}
            </div>
          </div>
          <div className="plan-list-content">
            <div className="table-view">
              <div className="table-content">
                <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                  <Table sx={{ width: "max-content", border: 'none' }}>
                    <TableHead className="tablehead">
                      <TableRow className="tablerow">
                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                          #
                        </TableCell>
                        <TableCell className="table-cell left" style={{ width: "auto", display: 'flex' }}>
                          <span>{t('name').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "180px" }}>
                          <span>{t('code').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "180px" }}>
                          <span>{t('year').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell left" style={{ maxWidth: "180px" }}>
                          <span>{t('status').toUpperCase()}</span>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody className="tablebody">
                      {paginatedPlans?.map((row, index) => (
                        <TableRow
                          key={row._id}
                          className={`${selectedPlan?._id === row._id ? "tablerow current" : "tablerow"}`}
                          onClick={() => {
                            try {
                              setSelectedPlan(row);
                              navigate(`/planning/${row._id}`);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        >
                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                            {currentPlanPage * rowsPerPage + index + 1}
                          </TableCell>
                          <TableCell className="table-cell left" style={{ width: "auto", display: "flex", flexDirection: "row", gap: "20px" }}>
                            <span style={{ fontWeight: "400", fontSize: "18px" }}>{row.plan_name}</span>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "180px" }}>
                            <span className="sub-title">{row.plan_code}</span>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "180px" }}>
                            <span className="sub-title">{row.plan_financial_year}</span>
                          </TableCell>
                          <TableCell className="table-cell left" style={{ maxWidth: "180px" }}>
                            <span className={`sub-title xrsmall status ${getCssValue(row?.plan_status)}`}>{row?.plan_status}</span>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  {plans?.length > rowsPerPage &&
                    <TablePagination
                      rowsPerPageOptions={[10]}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handlePlansRowsPerPage}
                      component="div"
                      count={plans?.length}
                      rows={plans}
                      page={currentPlanPage}
                      onPageChange={handlePlansPageChange}
                    />}
                </TableContainer>
              </div>
            </div>
          </div>
        </motion.div>
      )}
      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('reports')}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroupArray={reportGroupArray}
                documentData={{
                  docNo: "1",
                  docId: "1",
                  docType: "AllClaim",
                  format: "xlsx",
                  entity_code: "",
                  date_fm: "",
                  date_to: "",
                  status: "",
                }} />
            </div>
          </div>
        </motion.div>
      )}
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen} onClose={handleCloseNotifyDialog}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton currentTheme={currentTheme} onClick={handleCloseNotifyDialog}>Close</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        dialogTitle="Confirmation"
        dialogContent={<p>{objectToAction.action_text}</p>}
      />
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <GridLoader color="#bd97fc"
              style={{
                height: "50px",
                width: "50px",
              }}
            />
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default GlPlanList;
